<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <interest-create
      :ams_template="ams_template"
      :reroute="reroute"
    ></interest-create>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import InterestCreate from './InterestCreate.vue'

export default {
  components: {
    VuexBreadcrumb,
    InterestCreate
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    }
  }
}
</script>